import { useEffect } from 'react';

import { Outlet } from 'react-router';

interface StyleScopeProps {
    name: string;
}

export function StyleScope(props: Readonly<StyleScopeProps>) {
    const { name } = props;

    useEffect(() => {
        document.body.id = name;

        return () => {
            document.body.removeAttribute('id');
        };
    }, [name]);

    return <Outlet />;
}
